import useFetch from 'use-http';
import getProductsMock from './useProductsMock.js';
import RegisteredOnly from './useProducts.registeredOnly.json';
import useSearchParamOrDefaultProps from './useSearchParamOrDefaultProps.js';
import origins from './useProducts.origins.json';

const PATH = '/auth/api/v3/zuora/subscription/getRatePlans';
const BRAND = 'cnbc';
const PID = '33';

function useProducts(options) {
  const { offerGroup, resourceId, ratePlanId, mock, mockType } = options;
  const { windowTopLocationHref = window.location.href } =
    useSearchParamOrDefaultProps();
  const { origin: windowTopLocationOrigin } = new URL(windowTopLocationHref);
  const origin = windowTopLocationOrigin.endsWith('-sandbox.cnbc.com')
    ? origins.sandboxPhoenix
    : origins[windowTopLocationOrigin];

  if (mock === true) {
    const productsMock = getProductsMock(mockType);

    return productsMock;
  }

  const filterOptions = {};
  if (offerGroup) {
    filterOptions.offer_group = offerGroup;
  }

  if (resourceId) {
    filterOptions.resource_id = resourceId;
  }

  if (ratePlanId) {
    filterOptions.rate_plan_id = ratePlanId;
  }

  const { loading, error, data } = useFetch(
    origin + PATH,
    {
      method: 'POST',
      body: JSON.stringify({
        brand: BRAND,
        pid: PID,

        ...filterOptions,
      }),
    },
    [],
  );

  if (loading) {
    return { loading };
  }

  const { success, data: ratePlansGroupedByProduct = [] } = data || {};

  const isErrorState =
    (success === true && ratePlansGroupedByProduct.length === 0) || error;
  if (isErrorState) {
    return { loading, error };
  }

  const products = ratePlansGroupedByProduct.reduce(
    (ratePlansByProductId, productRatePlans) => {
      const { resource_id } = productRatePlans;

      ratePlansByProductId[resource_id] = {
        ...productRatePlans,
      };

      return ratePlansByProductId;
    },
    {
      // Special case for registered only product
      // since Zuora does not store registered only users
      // construct the product data here
      RegisteredOnly,
    },
  );

  return { loading, error, products };
}

export default useProducts;
